export enum SystemMessage {
  UNKNOWN_ERROR = "Something's wrong",
  INPUT_REQUIRED = "Không được để trống",
  INPUT_INVALID_PRICE = "Giá không hợp lệ",
  INPUT_INVALID_POINT = "Điểm không hợp lệ",
  COPY_SUCCESSFULLY = "Đã sao chép",
  ADD_SUCCESSFULLY = "Tạo thành công",
  UPDATE_SUCCESSFULLY = "Cập nhật thành công",
  DELETE_SUCCESSFULLY = "Xóa thành công",
  RESTORE_SUCCESSFULLY = "Khôi phục thành công",
  RESTORE_BOOK_NOTIFY = "Bạn có muốn khôi phục sách này?",
  DELETE_PERMANENTLY_BOOK_NOTIFY = "Bạn có chắc chắn muốn xóa vĩnh viễn sách này?",
  CONFIRM_SUCCESSFULLY = "Xác nhận thành công",
  DELETE_BOOK_NOTIFY = "Bạn có chắc chắn muốn xóa sách này?",
  DELETE_BANK_NOTIFY = "Bạn có chắc chắn muốn xóa ngân hàng này?",
  DELETE_VOICE_NOTIFY = "Bạn có chắc chắn muốn xóa voice này?",
  MAX_SIZE_UPLOAD = "Chọn file nhỏ hơn 512 MB",
  EMAIL_ADDRESS_INVALID = "Địa chỉ email không hợp lệ",
  FULL_NAME_REQUIRED = "Vui lòng nhập họ và tên của bạn.",
  USERNAME_REQUIRED = "Tên đăng nhập không thể để trống!",
  PASSWORD_REQUIRED = "Vui lòng nhập mật khẩu.",
  CONFIRM_PASSWORD_REQUIRED = "Vui lòng nhập lại mật khẩu.",
  CONFIRM_PASSWORD_INVALID = "Mật khẩu nhập lại không khớp.",
  AGREE_TERMS_REQUIRED = "Bạn chưa đồng ý với điều khoản sử dụng.",
  TIMEOUT = "Hết thời gian",
  ACCESS_DENIED = "Không có quyền truy cập",
  VERIFY_OTP_SUCCESSFULLY = "Xác nhận OTP thành công",
  VERIFY_OTP_FAILED = "Xác nhận OTP thất bại",
  LOGIN_FAILED = "Login Failed",
  CREATE_TRANSCRIPTION_SUCCESS = "Yêu cầu của bạn sẽ sớm được xử lý",
}
